import React, { useEffect, useState } from 'react';
import { useProfile } from '../data/store/useProfile';
import { useSongs } from '../data/store/useSongs';
import { usePlayer } from '../data/store/usePlayer';
import { usePlaylist } from '../data/store/usePlaylist';
import MediaService from '../services/MediaService';
import { useArtists } from '../data/store/useArtists';
import { IonImg } from '@ionic/react';
import { iconUrl } from '../config/env';

const LiteVisualizer = () => {
  const { darkMode } = useProfile();
  const { isPaused } = usePlayer();
  const { nowPlayingId } = usePlaylist();
  const song = useSongs((x) => x.retrieve(nowPlayingId!));

  return (
    song ? (
      <div style={{
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden'
      }}>
        <IonImg
          src={song.art?.src || Object.values(song?.artists || {'backup': {avatar: iconUrl('apple-touch-icon.png')}})[0].avatar}
          alt={`Now playing: ${song.title}`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      </div>
    ) : <></>
  );
};

export default LiteVisualizer;
